import axios from '@/utils/axios'
// 组件列表
export function list(query) {
    return axios({
        url: '/wb-sv/video/sinaReturnStrategy/getWeiBoReturnStrategy',
        method: 'get',
        params: query
    })
}
// 添加
export function add(query) {
    return axios({
        url: '/wb-sv/video/sinaReturnStrategy/addWeiBoReturnStrategy',
        method: 'post',
        data: query
    })
}
//详情
export function details(query) {
    return axios({
        url: '/wb-sv/video/sinaReturnStrategy/getWeiBoReturnStrategyById',
        method: 'get',
        params: query
    })
}

